import * as React from "react";
import { LabSuggestionsClusterPanels } from "../useBuildPlanPanels";
import { PatientCaseChange } from "../usePatientCase";
import { ThreeDotsLoader } from "fe-web-components/loader/threeDotsLoader";
import { PlanCluster } from "./planCluster";
import { styled } from "@mui/material";
import { scrollableStyleByColor } from "fe-common/ui/commonStyles";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

const PlanClustersView = styled("div")({
  ...scrollableStyleByColor(KahunColorMap.AccentLightScroll),
  height: "100%",
});

export type PlanClusterItemProps = {
  clusters: LabSuggestionsClusterPanels[];
  isEmbedded?: boolean;
  onPlanItemChange: (change: PatientCaseChange) => void;
  loading: boolean;
  maxItems: number;
};

export const PlanClusters = ({
  clusters,
  loading,
  maxItems,
  isEmbedded,
  onPlanItemChange,
}: PlanClusterItemProps) => {
  return (
    <PlanClustersView>
      {loading && <ThreeDotsLoader />}
      {!loading &&
        clusters
          .slice(0, maxItems || 10)
          .map((cluster, idx) => (
            <PlanCluster
              key={idx}
              index={idx}
              cluster={cluster}
              loading={loading}
              onPlanItemChange={onPlanItemChange}
              isEmbedded={isEmbedded}
            />
          ))}
    </PlanClustersView>
  );
};
